import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { MessageCircle, RefreshCw } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const API = `${BACKEND_URL}/api`;

const getAuthHeaders = () => {
  const token =
    sessionStorage.getItem("token") ||
    sessionStorage.getItem("authToken") ||
    sessionStorage.getItem("access_token") ||
    localStorage.getItem("token") ||
    "";
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const AiChatStatsWidget = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchStats = async () => {
    setLoading(true);
    try {
      const r = await axios.get(`${API}/chat/stats`, {
        headers: getAuthHeaders(),
        withCredentials: true,
      });
      setData(r.data || {});
    } catch (e) {
      console.error("[ai-chat-stats] fetch failed", e?.response?.status);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchStats(); }, []);

  const redemptionRate =
    data && data.coupons_issued > 0
      ? Math.round((data.coupons_redeemed / data.coupons_issued) * 100)
      : 0;

  return (
    <Card className="bg-gray-800 border-gray-700" data-testid="ai-chat-stats-widget">
      <CardHeader className="pb-3 flex flex-row items-center justify-between">
        <CardTitle className="text-white flex items-center gap-2 text-lg">
          <MessageCircle className="w-5 h-5 text-amber-400" />
          Assistente AI Chiara
        </CardTitle>
        <button
          type="button"
          onClick={fetchStats}
          disabled={loading}
          className="text-gray-300 hover:text-white p-1"
          data-testid="ai-chat-stats-refresh"
          aria-label="Aggiorna"
        >
          <RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} />
        </button>
      </CardHeader>
      <CardContent>
        {data ? (
          <div className="grid grid-cols-2 gap-3">
            <div className="bg-gray-900/60 rounded-lg p-3">
              <p className="text-[11px] text-gray-400 uppercase tracking-wide">Sessioni</p>
              <p className="text-2xl font-bold text-white mt-1" data-testid="ai-chat-sessions">
                {data.total_sessions}
              </p>
            </div>
            <div className="bg-gray-900/60 rounded-lg p-3">
              <p className="text-[11px] text-gray-400 uppercase tracking-wide">Messaggi</p>
              <p className="text-2xl font-bold text-white mt-1" data-testid="ai-chat-messages">
                {data.total_messages}
              </p>
            </div>
            <div className="bg-gray-900/60 rounded-lg p-3">
              <p className="text-[11px] text-gray-400 uppercase tracking-wide">Coupon emessi</p>
              <p className="text-2xl font-bold text-amber-400 mt-1" data-testid="ai-chat-coupons-issued">
                {data.coupons_issued}
              </p>
            </div>
            <div className="bg-gray-900/60 rounded-lg p-3">
              <p className="text-[11px] text-gray-400 uppercase tracking-wide">Coupon usati</p>
              <p className="text-2xl font-bold text-emerald-400 mt-1" data-testid="ai-chat-coupons-redeemed">
                {data.coupons_redeemed}
                <span className="text-xs text-gray-400 ml-1">({redemptionRate}%)</span>
              </p>
            </div>
          </div>
        ) : (
          <p className="text-sm text-gray-500 text-center py-4">
            {loading ? "Caricamento…" : "Nessun dato"}
          </p>
        )}
        <p className="text-[11px] text-gray-500 mt-3">
          Chatbot pubblico su sito · risponde con catalogo reale · può applicare un coupon -5% per sessione (7gg).
        </p>
      </CardContent>
    </Card>
  );
};

export default AiChatStatsWidget;
